import { Link, useRouteLoaderData } from '@remix-run/react'
import { type loader as rootLoader } from '#app/root.tsx'
import { ThemeSwitch } from '#app/routes/resources+/theme-switch.js'
import { Logo } from '#app/ui/components/custom/logo'
import { Container } from '#app/ui/components/verveui/layout/container'

export const Header = () => {
	const data = useRouteLoaderData<typeof rootLoader>('root')!

	return (
		<Container>
			<header className="py-6">
				<nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
					<Logo />
					<div className="flex items-center gap-10">
						<Link to="/blog" className="font-bold">
							Blog
						</Link>
						<ThemeSwitch userPreference={data.requestInfo.userPrefs.theme} />
					</div>
				</nav>
			</header>
		</Container>
	)
}
